import { Grid, Row, Col, Table, FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import StoreProduct from "./StoreProduct";
import { StyleSheet, css } from "aphrodite";

const styles = StyleSheet.create({
    marginTop: {
        marginTop: 20,
    },
});

const strings = {
    name: "Name",
    filterByName: "Filter By Name:",
    globalStatus: "Globally Active?",
    status: "86'd?",
    statusReason: "86'd Reason",
    edit: "Edit",
};

export default class StoreProductTab extends PureComponent {
    static propTypes = {
        onEdit: PropTypes.func.isRequired,
        products: PropTypes.array.isRequired,
        loading: PropTypes.bool.isRequired,
    };

    state = {
        filter: "",
    };

    _onFilterChange = e => {
        this.setState({ filter: e.target.value });
    };

    render() {
        const lowerFilter = this.state.filter.toLowerCase();
        const currentProducts = this.props.products.filter(
            p => p.name.toLowerCase().indexOf(lowerFilter) !== -1,
        );
        return (
            <Grid>
                <Row>
                    <Col className={css(styles.marginTop)} md={4}>
                        <FormGroup controlId="filter">
                            <ControlLabel>{strings.filterByName}</ControlLabel>
                            <FormControl
                                type="text"
                                value={this.state.filter}
                                placeholder={strings.enterText}
                                onChange={this._onFilterChange}
                                disabled={this.props.loading}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>{strings.name}</th>
                                    <th>{strings.globalStatus}</th>
                                    <th>{strings.status}</th>
                                    <th>{strings.statusReason}</th>
                                    <th>{strings.edit}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentProducts.map(p => (
                                    <StoreProduct
                                        key={p.id}
                                        product={p}
                                        onEdit={this.props.onEdit}
                                        loading={this.props.loading}
                                    />
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Grid>
        );
    }
}
